<footer class="footer">
	<div class="container">
		<div class="footer-content">

			<div class="logo">
				<img src="/assets/images/kwo-logo-yellow.png" alt="KWO">
			</div>
			<div class="copyright">
				<span>©&nbsp;{{ currentYear }} KWO. All rights reserved. </span>
			</div>
			<div class="links">
				<a href="https://www.kwo.nl/disclaimer-en-privacy/" target="_blank">Disclaimer en Privacy</a>
			</div>
		</div>
	</div>
</footer>